import SearchAdminSideBar from './SearchAdminSideBar';

export default SearchAdminSideBar;
